import classNames from "classnames";
import { Button } from "PFComponents/button";
import SidePanel from "PFComponents/side_panel/side_panel";
import EyeIcon from "PFIcons/eye.svg";
import EyeSlashIcon from "PFIcons/eye_slash.svg";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { formatFromStringToArray } from "../../../../../utils/utils";
import { VisibleCategory } from "../../../../types/types";
import css from "./select_tiles_to_render.module.scss";

type SelectTilesToRenderProps = {
  tilesCategories: VisibleCategory[];
  setVisibleCategories: Dispatch<SetStateAction<VisibleCategory[]>>;
};

const SelectTilesToRender = ({ tilesCategories, setVisibleCategories }: SelectTilesToRenderProps) => {
  const { t } = useTranslation("insights");
  const [open, setOpen] = useState(false);
  const [visibleTiles, setVisibleTiles] = useState<VisibleCategory[]>([]);

  useEffect(() => {
    setVisibleTiles(formatFromStringToArray(tilesCategories));
  }, [tilesCategories]);

  const handleCategoryUpdate = (categoryData) => {
    const newCategories = visibleTiles;
    const index = visibleTiles.findIndex((item) => item.category === categoryData.category);
    newCategories.splice(index, 1, { ...categoryData, visible: !categoryData.visible });

    setVisibleCategories(newCategories);
    setVisibleTiles(newCategories);
  };

  return (
    <div>
      <Button icon="table" kind="tertiary" className={css.button} onClick={() => setOpen(true)} />
      <SidePanel show={open} onClose={() => setOpen(false)} title={t("bookingReports.bookingCategories")}>
        <div className={css.title}>{t("bookingReports.editWidgets")}</div>
        <div className={css.columnButtonsContainer}>
          {visibleTiles?.map((catagoryData) => (
            <Button
              key={catagoryData.category}
              className={classNames(css.columnButton, { [css.inactive]: !catagoryData.visible })}
              style={{ margin: 0 }}
              kind="blank"
              onClick={() => handleCategoryUpdate(catagoryData)}
              qaId={`TablePropertiesVisibilityButton.${catagoryData.category}`}
            >
              {catagoryData.visible ? <EyeIcon /> : <EyeSlashIcon />}
              {catagoryData.category}
            </Button>
          ))}
        </div>
      </SidePanel>
    </div>
  );
};

export default SelectTilesToRender;
